<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div *ngIf="idSprNivel != idSprNivelN5">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
                    <div class="col-sm-6 text-sm-right" >
                        <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>
            </div>

            <div class="container card-body table-responsive ">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Estrategias</th>
                            <th>Objetivos</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataEstrategiasMain; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.estrategia}} </td>
                            <td>{{row.objetivo}}</td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>

                            <td class="text-center col-sm-auto">
                                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
                                    <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(row)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button  *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(row)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->
    <div class="modal-dialog" style="padding-top:5%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="closeModalEstrategias();" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <form class="needs-validation" novalidate id="formEstrategias" [formGroup]="formEstrategias">
                    <div class="row">

                        <div class="form-group row mb-2">
                            <input type="hidden" id="idSprObjetivo" formControlName="idSprEstrategia">
                            <div class="col col-md-2 text-md-right">
                                <label for="nombre" class=" form-control-label text-md-right pt-1"><b>Estrategia:</b></label>
                            </div>
                            <div class="col-12 col-md-10">
                                <textarea class="form-control" id="nombre" placeholder="" formControlName="nombre" rows="5" cols="30" required="true" [ngClass]="{'is-invalid': this.formEstrategias.get('nombre')?.errors  && this.submitted,  'is-valid': !this.formEstrategias.get('nombre')?.errors,  }">                                    </textarea>
                                <div class="col text-danger">
                                    <span class="font-italic" *ngIf="this.formEstrategias.get('nombre')?.errors?.['required'] && this.submitted">Campo requerido</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right ">
                                <label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
                            </div>
                            <div class="col-12 col-md-10 ">
                                <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                        'is-invalid': this.formEstrategias.get('estado')?.errors && this.submitted,
                        'is-valid': !this.formEstrategias.get('estado')?.errors,
                      }">
                                <option value="1" selected>Activo</option>
                                <option value="2">Inactivo</option>
                            </select>
                                <div class="col text-danger">
                                    <span class="font-italic" *ngIf="this.formEstrategias.get('estado')?.errors?.['required'] && this.submitted">Campo requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalEstrategias();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>
<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-estrategia" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>
